export default "__VITE_ASSET__Isya8TvW__"